import { FC } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import styles from './Sobre.module.scss';
import PageHeader from 'Components/UI/PageHeader/PageHeader';
import BreadCrumb, { IBreadcrumbItem } from 'Components/UI/BreadCrumb';

const Sobre: FC = () => {
  const { t } = useTranslation('sobre');

  const breadCrumb: IBreadcrumbItem[] = [
    { description: t('breadcrumb'), href: '/sobre' }
  ];

  const renderItems = (key: string) =>
    (t(key, { returnObjects: true }) as string[]).map((item, i) => (
      <li key={i}>{item}</li>
    ));

  return (
    <div className={styles['aboutWrapper']}>
      <PageHeader name={t('pageTitle')}>
        <div className={styles['breadCrumbAbout']}>
          <BreadCrumb breadcrumbs={breadCrumb} />
        </div>
        <div className={styles['pageAboutContainer']}>
          <p>{t('v60_title')}</p>
          <ul>{renderItems('v60_items')}</ul>

          <p>{t('v50_title')}</p>
          <ul>{renderItems('v50_items')}</ul>

          <p>{t('v40_title')}</p>
          <ul>
            {(t('v40_items', { returnObjects: true }) as string[]).map((item, i) => {
              if (i === 4) {
                return (
                  <li key={i}>
                    {item}
                    <ul>{renderItems('v40_viewerSubItems')}</ul>
                  </li>
                );
              }
              return <li key={i}>{item}</li>;
            })}
          </ul>

          <p>{t('v35_title')}</p>
          <ul>{renderItems('v35_items')}</ul>

          <p>{t('v342_title')}</p>
          <ul>{renderItems('v342_items')}</ul>

          <p>{t('v34_title')}</p>
          <ul>{renderItems('v34_items')}</ul>

          <p>{t('v33_title')}</p>
          <ul>{renderItems('v33_items')}</ul>

          <p>{t('v323_title')}</p>
          <ul>{renderItems('v323_items')}</ul>

          <p>{t('v32_title')}</p>
          <ul>
            <li>
              {t('v32_launchText')}
              <br />
              <Trans
                i18nKey="sobre:v32_watchVideo"
                components={{
                  link: (
                    <a href="https://youtu.be/J3yPa_x8VZw" target="_blank" rel="noreferrer" />
                  )
                }}
              >
                {t('v32_watchVideo')}{' '}
                <a href="https://youtu.be/J3yPa_x8VZw" target="_blank" rel="noreferrer">
                  {t('v32_clickHere')}
                </a>
              </Trans>
            </li>
          </ul>

          <p>{t('v31_title')}</p>
          <ul>{renderItems('v31_items')}</ul>

          <p>{t('v30_title')}</p>
          <ul>{renderItems('v30_items')}</ul>

          <p>{t('v22_title')}</p>
          <ul>{renderItems('v22_items')}</ul>

          <p>{t('v21_title')}</p>
          <ul>{renderItems('v21_items')}</ul>

          <p>{t('v20_title')}</p>
          <ul>
            {(t('v20_items', { returnObjects: true }) as string[]).map((item, i) => {
              if (i === 5) {
                return (
                  <li key={i}>
                    {item}
                    <ul>{renderItems('v20_memberPrograms')}</ul>
                  </li>
                );
              }
              return <li key={i}>{item}</li>;
            })}
          </ul>

          <div className={styles['footerAbout']}>
            <p>{t('rights')}</p>
          </div>
        </div>
      </PageHeader>
    </div>
  );
};

export default Sobre;
